import React from 'react'
import { Route, Routes } from 'react-router-dom'

// Pages
import Changepassword from './pages/ChangePassword/Changepassword'
import Dashboard from './pages/Dashboard/Dashboard.jsx'
import NotFound from './pages/NotFound/NotFound'
import Notification from './pages/Notification/Notification'
import EditProfile from './pages/editProfile/EditProfile'
import ForgotPassword from './pages/forgot-password/ForgotPassword'
import ResetPassword from './pages/forgot-password/ResetPassword'
import Login from './pages/login/Login.jsx'

// Category related
import AssignCategory from './pages/category/category-attributes/AssignCategory'
import ManageFilter from './pages/category/category-attributes/ManageFilter'
import ManageAttributes from './pages/category/manage-attributes/ManageAttributes'
import ManageCategory from './pages/category/manage-category/ManageCategory'

// Product related
import AddProduct from './pages/product/AddProduct'
import ArchiveProducts from './pages/product/ArchiveProducts'
import ManageProduct from './pages/product/ManageProduct'

// Order related
import InvoiceTabbing from './pages/CustomerInvoice/InvoiceTabbing.jsx'
import FailedOrderTabbing from './pages/Order/FailedList/FailedOrderTabbing.jsx'
import InitiateOrderTabbing from './pages/Order/InitiatList/InititateOrderTabbing.jsx'
import ManageOrder from './pages/Order/OrderList/ManageOrder'
import ManageReturnList from './pages/Order/ReturnList/ManageReturnList'

// Settings and Configuration
import LendingPageSection from './pages/settings/LendingPage/LendingPageSection'
import CreateCoupon from './pages/settings/ManageCoupons/CreateCoupon'
import ManageCoupons from './pages/settings/ManageCoupons/ManageCoupons'
import ManageHeader from './pages/settings/ManageMenu/ManageHeader'
import Setting from './pages/settings/Setting'
import ManageSeller from './pages/settings/seller/ManageSeller'
import SellerDetails from './pages/settings/seller/SellerDetails'

// Logs and Reports
import LogTabbing from './pages/Logs/LogTabbing'
import BrandTabbing from './pages/ManageBrand/BrandTabbing'

// Inventory Management
import InventoryModelTabbing from './pages/InventoryModelManagement/InventoryModelTabbing.jsx'

// Protected Route
import ProtectedRoute from './lib/ProtectedRoute'
import ManageReport from './pages/ManageReport/ManageReport.jsx'
import UserTabbing from './pages/ManageUser/UserTabbing.jsx'
import ExistingProductForm from './pages/product/AddInExisting/ExistingProductForm.jsx'
import ExistingProductList from './pages/product/AddInExisting/ExistingProductList.jsx'

const AllRoutes = () => {
  return (
    <Routes>
      {/* Authentication Routes */}
      <Route exact path='/login' element={<Login />} />
      <Route exact path='/forgot-password' element={<ForgotPassword />} />
      <Route exact path='/reset/:token/:uid' element={<ResetPassword />} />

      <Route element={<ProtectedRoute />}>
        {/* Categories */}
        <Route
          exact
          path='/category/manage-category'
          element={<ManageCategory />}
        />
        <Route
          exact
          path='/category/manage-attributes'
          element={<ManageAttributes />}
        />
        <Route
          exact
          path='/category/assign-category'
          element={<AssignCategory />}
        />
        <Route
          exact
          path='/category/assign-category/manage-filter'
          element={<ManageFilter />}
        />

        {/* General */}
        <Route exact path='/dashboard' element={<Dashboard />} />
        <Route exact path='/logs' element={<LogTabbing />} />
        <Route exact path='/notification' element={<Notification />} />
        <Route exact path='/manage-user' element={<UserTabbing />} />
        <Route exact path='/report' element={<ManageReport />} />

        {/* UserModules */}
        <Route
          exact
          path='/settings/change-password'
          element={<Changepassword />}
        />
        <Route exact path='/edit-profile' element={<EditProfile />} />

        {/* Settings */}
        <Route exact path='/settings' element={<Setting />} />
        <Route
          exact
          path='/settings/manage-sub-menu'
          element={<ManageHeader />}
        />
        <Route
          exact
          path='/settings/lending-page-section'
          element={<LendingPageSection />}
        />

        {/* Seller modules */}
        <Route exact path='/manage-seller' element={<ManageSeller />} />
        <Route
          exact
          path='/manage-seller/seller-details/:id'
          element={<SellerDetails />}
        />
        <Route exact path='/im-warehouse' element={<InventoryModelTabbing />} />

        <Route exact path='/manage-brand' element={<BrandTabbing />} />

        {/* Product */}
        <Route exact path='/manage-product' element={<ManageProduct />} />
        <Route
          exact
          path='/manage-product/add-product'
          element={<AddProduct />}
        />
        <Route
          exact
          path='/existing-product-form/:id'
          element={<ExistingProductForm />}
        />
        <Route
          exact
          path='/existing-product'
          element={<ExistingProductList />}
        />
        <Route
          exact
          path='/manage-product/archive-products'
          element={<ArchiveProducts />}
        />

        {/* Coupon section */}
        <Route exact path='/manage-coupons' element={<ManageCoupons />} />
        <Route
          exact
          path='/manage-coupons/create-coupon'
          element={<CreateCoupon />}
        />

        {/* Orders */}
        <Route exact path='/order' element={<ManageOrder />} />
        <Route exact path='/return-list' element={<ManageReturnList />} />
        <Route
          exact
          path='/initiate-order'
          element={<InitiateOrderTabbing />}
        />
        <Route exact path='/failed-order' element={<FailedOrderTabbing />} />

        {/* Customer Invoice */}
        <Route exact path='/customer-invoice' element={<InvoiceTabbing />} />
      </Route>

      <Route
        path='*'
        element={
          <NotFound
            title='Page Not Found'
            subTitle='Sorry, the page you are looking for does not exist.'
          />
        }
      />
    </Routes>
  )
}

export default AllRoutes
